"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionPanelContent = exports.ActionPanel = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ActionPanel = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    right: 0;\n    bottom: -60px;\n    height: 60px;\n    width: 100%;\n    z-index: 100;\n\n    transition: bottom 0.3s ease-in-out;\n\n    ", "\n\n    &.active {\n        bottom: 0;\n    }\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        width: calc(100% - 290px);\n    "]))));

exports.ActionPanel = ActionPanel;

var ActionPanelContent = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    max-width: 900px;\n    padding: 10px;\n    background-color: #fff;\n    box-shadow: 0 0px 3px -1px #c7c7c7;\n\n    p {\n        margin-bottom: 0;\n    }\n"])));

exports.ActionPanelContent = ActionPanelContent;